import * as THREE from "three";
export const generarSceneTexto = (nombre) => {
  const scene = new THREE.Scene();
  scene.userData.nombre = nombre;
  const element2 = document.createElement("div");
  //   const element2 = ref.current;
  // element2.className = "w-100 mx-auto d-block";
  element2.className = "col-md-12";

  const element = document.createElement("div");
  element.id = "prueba-texto";
  // element.className = "list-item col-md-4 col-lg-3";
  element.className = "list-item-texto";
  element2.appendChild(element);

  const sceneElement = document.createElement("div");

  // element.style.zIndex = "10";
  element.appendChild(sceneElement);
  sceneElement.className = "prueba3";
  const descriptionElement = document.createElement("div");
  // descriptionElement.innerText = "Escena principal2 ";
  element.appendChild(descriptionElement);

  // const boton = document.createElement("button");
  // boton.style.width = " 100px";
  // boton.style.height = "100px";

  // boton.innerHTML = "boton 2";
  // element.appendChild(boton);

  // the element that represents the area we want to render the scene
  scene.userData.element = sceneElement;

  //   const light = new THREE.DirectionalLight(0xffffff, 0.5);
  //   light.position.set(1, 1, 1);
  //  scene.add(light);
  // console.log("scene es, ", scene);
  //   scene.background = new THREE.Color("#CCCCCC");
  // const camera = new THREE.PerspectiveCamera(50, 1, 1, 10);
  // camera.position.z = 2;
  const camera = new THREE.PerspectiveCamera(40, 1, 1, 10000);
  camera.position.set(-100, 0, 200);
  scene.userData.camera = camera;

  // const controls = new OrbitControls(
  //   scene.userData.camera,
  //   scene.userData.element
  // );
  // controls.minDistance = 2;
  // controls.maxDistance = 5;
  // controls.enablePan = false;
  // controls.enableZoom = true;
  // scene.userData.controls = controls;

  /**
   * Lights
   */
  //   const directionalLight = new THREE.DirectionalLight("#ffffff", 1);
  //   directionalLight.position.set(0, 3, 1);
  //   scene.add(directionalLight);
  //   const directionalLight2 = new THREE.DirectionalLight("#ffffff", 1);
  //   directionalLight2.position.set(0, 0, 2);
  //   scene.add(directionalLight2);
  //   const directionalLight3 = new THREE.DirectionalLight("#ffffff", 5);
  //   directionalLight3.position.set(2, 0, -0.5);
  //   scene.add(directionalLight3);
  //   const directionalLight4 = new THREE.DirectionalLight("#ffffff", 5);
  //   directionalLight4.position.set(-2, 0, -0.5);
  //   scene.add(directionalLight4);

  //   const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
  //   scene.add(ambientLight);

  return [scene, element2];
};
